import { Injectable } from '@angular/core';

import { PaymentType } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class PaymentTypeService extends TmsWebBaseEditService<PaymentType, PaymentType> {
  constructor() {
    super('PaymentType', $localize`Payment Type`);
  }
}
